import api from '~/api'
import get from 'lodash/get'

let scopesLoadedResolveFn
const loadedPromise = new Promise(resolve => {
  scopesLoadedResolveFn = resolve
})

const state = {
  user: null,
  provider: {},
  supplier: null,
  scopes: [],
  roles: [],
  loadedPromise,
}

const getters = {
  hasPermission: s => key => s.scopes.indexOf(key) !== -1,

  meUser: s => s.user,
  meProvider: s => s.provider,
  meProviderName: s => get(s.provider, 'name', ''),
  meProviderId: s => get(s.provider, 'external_id', ''),
  meSupplierId: s => get(s.supplier, 'external_id', ''),
  isSupplierAdmin: s => s.roles.includes('estore:supplier_admin'),
  scopes: s => s.scopes,

  canCreateApiKey: s => s.scopes.includes('api_key:create'),
  canDeleteApiKey: s => s.scopes.includes('api_key:delete'),
  canReadApiKey: s => s.scopes.includes('api_key:read'),
  canUpdateApiKey: s => s.scopes.includes('api_key:update'),

  canSwitchProvider: s => s.scopes.includes('provider:switch'),
  canReadProvider: s => s.scopes.includes('provider:read'),
  canSearchProvider: s => s.scopes.includes('provider:search'),
  canCreateProvider: s => s.scopes.includes('provider:create'),
  canUpdateProvider: s => s.scopes.includes('provider:update'),

  // Provider Catalogue Publish Details page - Decline button/modal
  providerPublishInternalDecline: s => s.scopes.includes('provider:publish_internal_decline'),
  // Provider Catalogue Publish Details page - Approve button/modal
  providerPublishExternal: s => s.scopes.includes('provider:publish_external'),
  // Provider Details page - Publish tab
  // Provider Details page - Update Catalogue from Suppliers button
  // Provider Details page -  Publish Catalogue Externally button
  // Provider Catalogue Publish Details page - Information tab
  providerPublishInternal: s => s.scopes.includes('provider:publish_internal'),
  // Provider Catalogue Publish Details page - Products Deleted tab
  providerPublishedProductDeleted: s => s.scopes.includes('provider:published_product_deleted'),
  // Provider Catalogue Publish Details page - Products Added tab
  providerPublishedProductNew: s => s.scopes.includes('provider:published_product_new'),
  // Provider Catalogue Publish Details page - Products Updated tab
  providerPublishedProductUpdated: s => s.scopes.includes('provider:published_product_updated'),

  canSearchProviderProduct: s => s.scopes.includes('provider_product:search'),
  canReadProviderProduct: s => s.scopes.includes('provider_product:read'),
  canListProviderProduct: s => s.scopes.includes('provider_product:list'),
  canUpdateProviderProduct: s => s.scopes.includes('provider_product:update'),
  canDeleteProviderProduct: s => s.scopes.includes('provider_product:delete'),

  canSearchSupplier: s => s.scopes.includes('supplier:search'),
  canReadSupplier: s => s.scopes.includes('supplier:read'),
  canCreateSupplier: s => s.scopes.includes('supplier:create'),
  canUpdateSupplier: s => s.scopes.includes('supplier:update'),
  canDeleteSupplier: s => s.scopes.includes('supplier:delete'),

  canSearchSupplierProduct: s => s.scopes.includes('supplier_product:search'),
  canReadSupplierProduct: s => s.scopes.includes('supplier_product:read'),
  canListAllSupplierProduct: s => s.scopes.includes('supplier_product:list_all'),
  canCreateSupplierProduct: s => s.scopes.includes('supplier_product:create'),
  canUpdateSupplierProduct: s => s.scopes.includes('supplier_product:update'),
  canDeleteSupplierProduct: s => s.scopes.includes('supplier_product:delete'),

  canSearchOrder: s => s.scopes.includes('order:search'),
  canReadOrder: s => s.scopes.includes('order:read'),

  canSearchOrderItems: s => s.scopes.includes('order_items:search'),
  canReadOrderItems: s => s.scopes.includes('order_items:read'),
  // canCreateOrderItems: s => s.scopes.includes('order_items:create'),
  canUpdateOrderItems: s => s.scopes.includes('order_items:update'),
  canListOrderItems: s => s.scopes.includes('order_items:list'),
  // canDeleteOrderItems: s => s.scopes.includes('order_items:delete'),

  canSearchContract: s => s.scopes.includes('contract:search'),
  canReadContract: s => s.scopes.includes('contract:read'),
  canCreateContract: s => s.scopes.includes('contract:create'),
  canUpdateContract: s => s.scopes.includes('contract:update'),
  canDeleteContract: s => s.scopes.includes('contract:delete'),
  canListContract: s => s.scopes.includes('contract:list'),
  canReadContractAttributeConfiguration: s => s.scopes.includes('contract_attribute_configuration:read'),
  canUpdateContractAttributeConfiguration: s => s.scopes.includes('contract_attribute_configuration:update'),

  canSearchCategoryTree: s => s.scopes.includes('category_tree:search'),
  canReadCategoryTree: s => s.scopes.includes('category_tree:read'),
  canCreateCategoryTree: s => s.scopes.includes('category_tree:create'),
  canUpdateCategoryTree: s => s.scopes.includes('category_tree:update'),
  canDeleteCategoryTree: s => s.scopes.includes('category_tree:delete'),
}

const mutations = {
  SET_SCOPES(state, payload) {
    state.provider = payload.provider || {
      external_id: payload.provider_id,
    }
    state.supplier = payload.supplier || {
      external_id: payload.supplier_id,
    }
    state.scopes = Object.keys(payload.permissions || [])
    state.user = payload.user || {}
    state.roles = Object.keys(payload.roles || [])
  },
}

const actions = {
  async getMe({ commit }) {
    const result = await api.get('/me')
    const [error, success] = result

    if (!error) {
      commit('SET_SCOPES', success)

      scopesLoadedResolveFn()
    }

    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
